export default "__VITE_ASSET__Da6y6CSN__"